import { AbstractExternalAPIHandler } from './AbstractExternalAPIHandler';
import { PLATFORM_BREAKPOINT_RANGES } from '@wix/editor-platform-host-integration-apis';
export class ExternalStageHandler extends AbstractExternalAPIHandler {
  getBreakpointFromPointer(editorPointer) {
    return this.hostAPI.stage.getBreakpointFromPointer(editorPointer, PLATFORM_BREAKPOINT_RANGES);
  }
}
//# sourceMappingURL=ExternalStageHandler.js.map